// @flow

import {
    MATERIAL_LIST_CLOSE,
    MATERIAL_LIST_OPEN
} from './actionTypes';

/**
 * Action to close the material list.
 *
 * @returns {Object}
 */
export const close = () => {
    return {
        type: MATERIAL_LIST_CLOSE
    };
};

/**
 * Action to open the material list.
 *
 * @returns {Object}
 */
export const open = () => {
    return {
        type: MATERIAL_LIST_OPEN
    };
};
